var exports = {
  "ds": "compactContainer__uY2q9q",
  "xn": "compactAgentsMenu__it5dNn",
  "Yv": "largeButton__u964Fd",
  "Lw": "overlay__F-f7yX",
  "J1": "ssoSkeleton__pWW6ru",
};

module.exports = exports;
